import { render } from "./StackedListItem.vue?vue&type=template&id=c24c9e8c&scoped=true"
import script from "./StackedListItem.vue?vue&type=script&lang=js"
export * from "./StackedListItem.vue?vue&type=script&lang=js"

import "./StackedListItem.vue?vue&type=style&index=0&id=c24c9e8c&lang=postcss&scoped=true"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24c9e8c"]])

export default __exports__